(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/quickplay-modal/assets/javascripts/coupons/coupon-number-board.js') >= 0) return;  svs.modules.push('/components/sport/quickplay-modal/assets/javascripts/coupons/coupon-number-board.js');
"use strict";


const ReactButtonBet = svs.components.ReactButtonBet;
const _svs$components$lbUti = svs.components.lbUtils.useMediaQuery,
  useMediaQuery = _svs$components$lbUti.useMediaQuery,
  breakpoints = _svs$components$lbUti.breakpoints,
  BREAKPOINT_SM = _svs$components$lbUti.BREAKPOINT_SM;

const MatchRow = _ref => {
  let eventItem = _ref.eventItem,
    eventIndex = _ref.eventIndex,
    branding = _ref.branding,
    productId = _ref.productId,
    isMobile = _ref.isMobile,
    isPixMix = _ref.isPixMix;
  const captionShort = eventItem.captionShort,
    captionLong = eventItem.captionLong,
    infoLine = eventItem.infoLine;
  return React.createElement("div", {
    className: "u-flex u-flex-justify-content-between u-border-bottom-1 border-opacity-white-60 notranslate",
    key: "".concat(captionShort, "-").concat(eventIndex)
  }, React.createElement("div", {
    className: "margin-top margin-bottom",
    "data-testid": "event-".concat(eventIndex, "-description")
  }, React.createElement("div", null, "".concat(eventIndex + 1, ". ").concat(isMobile ? captionShort : captionLong)), Boolean(infoLine) && React.createElement("div", {
    className: "padding-left-1 fc-grey-400"
  }, infoLine)), React.createElement("div", {
    className: "u-flex f-100 fc-white quickplay-modal-outcomes",
    "data-testid": "event-".concat(eventIndex, "-outcomes")
  }, React.createElement(EventOutcomes, {
    branding: branding,
    eventIndex: eventIndex,
    isPixMix: isPixMix,
    productId: productId
  })));
};

const EventOutcomes = _ref2 => {
  let eventIndex = _ref2.eventIndex,
    branding = _ref2.branding,
    productId = _ref2.productId,
    isPixMix = _ref2.isPixMix;
  const pixHandler = svs.components.sport.pixHandler.getPixHandler({
    isPixMix
  }); 
  const pixData = pixHandler.getModel(productId);
  const signs = (pixData === null || pixData === void 0 ? void 0 : pixData.map(board => board[eventIndex])) || [];
  return React.createElement(React.Fragment, null, signs.map((isSelected, signIndex) => {
    if (isSelected) {
      return React.createElement("div", {
        className: "quickplay-modal-selection"
        ,
        key: "".concat(eventIndex, "_").concat(signIndex)
      }, React.createElement(ReactButtonBet, {
        "aria-hidden": "true",
        branding: branding,
        className: "margin-half",
        label: "X",
        selected: true,
        size: "200",
        tabIndex: "-1"
      }));
    }
    return React.createElement("div", {
      className: "quickplay-modal-selection-empty"
      ,
      key: "".concat(eventIndex, "_").concat(signIndex)
    });
  }).filter(Boolean));
};

const CouponNumberBoard = _ref3 => {
  let branding = _ref3.branding,
    drawData = _ref3.drawData,
    isPixMix = _ref3.isPixMix;
  const _ref4 = drawData || {},
    productId = _ref4.productId,
    events = _ref4.events;
  const isMobile = useMediaQuery(breakpoints.down(BREAKPOINT_SM));
  return React.createElement("div", {
    className: "padding-left-2 padding-right-2"
  }, React.createElement("div", {
    className: "f-medium u-flex u-flex-justify-content-between u-border-bottom-1 border-opacity-white-60 fc-opacity-white-80"
  }, React.createElement("div", null, "Match"), React.createElement("div", {
    "data-testid": "table-of-events-goal-type"
  }, React.createElement("div", {
    className: "table-of-events-goal-type-rows"
  }, "M\xE5lrikaste Matcher"))), events.map((eventItem, eventIndex) => React.createElement(MatchRow, {
    branding: branding,
    eventIndex: eventIndex,
    eventItem: eventItem,
    isMobile: isMobile,
    isPixMix: isPixMix
    ,
    key: "".concat(eventItem.captionShort, "_").concat(eventIndex),
    productId: productId
  })));
};
setGlobal('svs.components.sport.quickplayModal.coupons.CouponNumberBoard', CouponNumberBoard);

 })(window);